import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import BaseService from "../../../../services/BaseService";
import { useLocation, useNavigate } from "react-router-dom";
import LeaderShipService from "../../../../services/LeaderShipService";
import OurBoardService from "../../../../services/OurBoardService";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const AddLeadership = () => {
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		job_en: "",
		job_ar: "",
		image: "",
		description_en: EditorState.createEmpty(),
		description_ar: EditorState.createEmpty(),
	});
	const [errors, setErrors] = useState({
		title_en: false,
		title_ar: false,
		description_en: false,
		description_ar: false,
	});
	const location = useLocation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [type, setType] = useState("");
	const [loadingImg, setLoadingImg] = useState(false);
	const [isAdd, setIsAdd] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const Service =
		type === "leadership" ? new LeaderShipService() : new OurBoardService();

	useEffect(() => {
		setType(location?.state?.type);
		let item = location?.state?.item || {};
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name_en: item?.name_en,
				name_ar: item?.name_ar,
				job_en: item?.job_title_en,
				description_en: EditorState.createWithContent(
					ContentState.createFromBlockArray(
						htmlToDraft(item?.description_en?.replaceAll("&lt;", "<"))
					)
				),
				description_ar: EditorState.createWithContent(
					ContentState.createFromBlockArray(
						htmlToDraft(item?.description_ar?.replaceAll("&lt;", "<"))
					)
				),
				job_ar: item?.job_title_ar,
				image: item?.image,
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();

		// if (
		// 	(type === "ourboard" &&
		// 		!draftToHtml(
		// 			convertToRaw(formData?.description_en.getCurrentContent())
		// 		)?.replace("<p></p>\n", "")) ||
		// 	(type === "ourboard" &&
		// 		!draftToHtml(
		// 			convertToRaw(formData?.description_ar.getCurrentContent())
		// 		)?.replace("<p></p>\n", ""))
		// ) {
		// 	setErrors({
		// 		description_en: !draftToHtml(
		// 			convertToRaw(formData?.description_en.getCurrentContent())
		// 		)?.replace("<p></p>\n", ""),
		// 		description_ar: !draftToHtml(
		// 			convertToRaw(formData?.description_ar.getCurrentContent())
		// 		)?.replace("<p></p>\n", ""),
		// 	});
		// 	return;
		// }

		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			job_title_en: formData?.job_en,
			job_title_ar: formData?.job_ar,
			image: formData?.image,
		};
		if (type === "ourboard") {
			data["description_en"] = draftToHtml(
				convertToRaw(formData?.description_en.getCurrentContent())
			);
			data["description_ar"] = draftToHtml(
				convertToRaw(formData?.description_ar.getCurrentContent())
			);
		}

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate("/leadership-ourboard", { state: type });
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate("/leadership-ourboard", { state: type });
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e, name) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!!filesData?.length) {
			setLoadingImg(true);
			new BaseService()
				.postUpload(filesData[0])
				.then((res) => {
					if (res?.data?.status) {
						setFormData({ ...formData, [name]: res.data.url });
					}
					setLoadingImg(false);
				})
				.catch(() => setLoadingImg(false));
		}
	};

	return (
		<div>
			<AvForm className="form-horizontal add-parking" onValidSubmit={submit}>
				<div>
					<Row>
						<Col md={12} className="mb-3">
							<div className="d-flex align-items-center gap-12">
								<i
									className="las la-arrow-left fs-28 cursor-pointer"
									onClick={() => {
										navigate("/leadership-ourboard", { state: type });
									}}></i>
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang][type]}
								</p>
							</div>
						</Col>

						{/* Name En */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.english_name}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.english_title}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) =>
									setFormData({
										...formData,
										name_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.arabic_name}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.arabic_title}
								bsSize="lg"
								name="name_ar"
								pattern="[\u0600-\u06FF\s]+"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										name_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Job En */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.job} ({Translate[lang]?.english_title})
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.english_title}
								bsSize="lg"
								name="job_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.job_en}
								onChange={(e) =>
									setFormData({
										...formData,
										job_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Job Ar */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.job} ({Translate[lang]?.arabic_title})
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.arabic_title}
								bsSize="lg"
								name="job_ar"
								pattern="[\u0600-\u06FF\s]+"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.job_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										job_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Description*/}
						{type === "ourboard" && (
							<>
								<Col md={6} className="mb-3">
									<label className="text-label">
										{Translate[lang]?.english_description}
										{/* <span className="star-require">*</span> */}
									</label>
									<Editor
										editorState={formData?.description_en}
										toolbarClassName="toolbarClassName"
										wrapperClassName="wrapperClassName"
										editorClassName="editorClassName"
										onEditorStateChange={(e) => {
											setFormData((prev) => ({ ...prev, description_en: e }));
											setErrors((prev) => ({ ...prev, description_en: false }));
										}}
									/>
									{errors.description_en && (
										<p
											className="text-danger m-0"
											style={{ fontSize: "12.8px" }}>
											{Translate[lang].field_required}
										</p>
									)}
								</Col>
								<Col md={6} className="mb-3">
									<label className="text-label">
										{Translate[lang]?.arabic_description}
										{/* <span className="star-require">*</span> */}
									</label>
									<Editor
										editorState={formData?.description_ar}
										toolbarClassName="toolbarClassName"
										wrapperClassName="wrapperClassName"
										editorClassName="editorClassName"
										onEditorStateChange={(e) => {
											setFormData((prev) => ({ ...prev, description_ar: e }));
											setErrors((prev) => ({ ...prev, description_ar: false }));
										}}
									/>
									{errors.description_ar && (
										<p
											className="text-danger m-0"
											style={{ fontSize: "12.8px" }}>
											{Translate[lang].field_required}
										</p>
									)}
								</Col>
							</>
						)}

						{/* Image */}
						<Col md={6}>
							<label className="text-label mb-0">
								{Translate[lang].image}
								<span className="star-require">*</span>
							</label>
							<div className="upload">
								<input
									type="file"
									name="image"
									id="image"
									disabled={loadingImg}
									onChange={(e) => fileHandler(e, "image")}
								/>
								<p>{Translate[lang].upload_image}</p>
								{!formData?.image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.image && (
								<div className="d-flex flex-column mt-3 position-relative">
									<i
										className="las la-trash fs-20 text-danger cursor-pointer"
										onClick={() =>
											setFormData((prev) => ({ ...prev, image: "" }))
										}
									/>
									<img
										src={formData?.image}
										alt="license_image"
										width={80}
										className="mt-1"
									/>
								</div>
							)}
						</Col>
					</Row>
				</div>
				<div>
					<Button
						variant="primary"
						type="submit"
						className="w-50 mt-5"
						disabled={loading || loadingImg}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang][type]}
					</Button>
				</div>
			</AvForm>
		</div>
	);
};

export default AddLeadership;
